<template>
    <modal-entering-visit-pay id="entering-visit-pay-dialog"
                              ref="currentVpModal"
                              :returnToPageText="this.cmsContentBlocks.continueToVisitPay"
                              :headerText="this.cmsContentBlocks.enteringVisitPayModalHeader"
                              :modalText="this.cmsContentBlocks.enteringVisitPayModalBody"
                              :modalBackdrop="'true'"
                              @onClose="proceedToVisitPay">
    </modal-entering-visit-pay>
</template>
<script>
    import Vue from 'vue';
    import VueCookies from 'vue-cookies';
    import './entering.visit.pay.scss';
    import { VisitPayHttpSvc } from '@PortalHttpServices/portal.visit.pay.httpservice';
    import modalEnteringVisitPayComponent from './modal.entering.visit.pay.vue';
    export default {
        name: 'enteringVisitPayModal',
        props: {
            url: { type: String },
            userItem: { type: String }
        },
        components: {
            'modal-entering-visit-pay': modalEnteringVisitPayComponent,
        },
        data: function () {
            return {
                isLoading: true,
                mode: 'Entry',
                showEnteringVisitPayModalStorageId: '__VPProceed',
                //cms content blocks
                cmsContentBlocks: {},
                currentUser: {},
                errorModel: {},
                visitPayUrl: this.url
            }
        },
        mounted() {
            VisitPayHttpSvc.EnteringVisitPayModalInit()
                .done(response => {
                    this.cmsContentBlocks = response.cmsContentBlocks;
                    this.currentUser = response.currentUser;
                });
            $('#entering-visit-pay-modal').on("vpclick", (event, url) => {
                this.showModalOrContinue(url)
            });
        },
        computed: {
        },
        watch: {
        },
        methods: {
            showModalOrContinue: function (url) {
                this.visitPayUrl = url;
                if (!window.$cookies.get(this.showEnteringVisitPayModalStorageId)) {
                    $('#entering-visit-pay-dialog').modal('show');
                } else {
                    window.location.href = url;
                }
            },
            proceedToVisitPay() {
                window.$cookies.set(this.showEnteringVisitPayModalStorageId, 1, "1y");
                window.location.href = this.visitPayUrl;
            },
            dismissModal() {
                $('#entering-visit-pay-dialog').modal('hide')
            }
        }
    };
</script>

